import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { DialogUpdatedComponent } from './dialog-updated.component';

@NgModule({
  entryComponents: [
    DialogUpdatedComponent
  ],
  declarations: [
    DialogUpdatedComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [
    DialogUpdatedComponent
  ]
})
export class DialogUpdatedModule { }
